/**
 * External dependencies
 */
import has from 'lodash/has';

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment, useState } from '@wordpress/element';
import { ButtonGroup, IconButton, __experimentalUnitControl as UnitControl, BaseControl } from '@wordpress/components';

/**
 * Padding controls
 *
 * @param props
 */
const PaddingControl = ( props ) => {
	const { value, label, id, help, disabled = false, onChange } = props;
	const desktop = has( value, `desktop` ) ? value.desktop : {};
	const tablet = has( value, `tablet` ) ? value.tablet : {};
	const mobile = has( value, `mobile` ) ? value.mobile : {};

	const units = [
		{ value: 'px', label: 'px', default: '' },
		{ value: '%', label: '%', default: '' },
		{ value: 'em', label: 'em', default: '' },
	];

	const [ compState, setState ] = useState( {
		device: 'desktop',
	} );

	const updateValues = ( data ) => {
		const values = {
			...value,
			...data,
		};

		onChange( values );
	};
	return <div className="padding-control-wrapper">
		<BaseControl
			label={ label }
			id={ id }
			help={ help }
		>
			<div className="padding-actions-area">
				<ButtonGroup>
					<IconButton
						disabled={ disabled }
						icon="desktop"
						label={ __( 'Desktop' ) }
						isPrimary={ 'desktop' === compState.device }
						onClick={ () => {
							setState( {
								device: 'desktop',
							} );
						} }
					/>
					<IconButton
						disabled={ disabled }
						icon="tablet"
						label={ __( 'Tablet' ) }
						isPrimary={ 'tablet' === compState.device }
						onClick={ () => {
							setState( {
								device: 'tablet',
							} );
						} }
					/>
					<IconButton
						disabled={ disabled }
						icon="smartphone"
						label={ __( 'Mobile' ) }
						isPrimary={ 'mobile' === compState.device }
						onClick={ () => {
							setState( {
								device: 'mobile',
							} );
						} }
					/>
				</ButtonGroup>
			</div>
			<div className="padding-fields-area">
				{ 'desktop' === compState.device && <Fragment>
					<UnitControl
						disabled={ disabled }
						label={ __( 'Top' ) }
						value={ desktop.top }
						onChange={ ( val ) => {
							const _padding = {
								...desktop,
								...{ top: val },
							};
							updateValues( { desktop: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Right' ) }
						value={ desktop.right }
						onChange={ ( val ) => {
							const _padding = {
								...desktop,
								...{ right: val },
							};
							updateValues( { desktop: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Bottom' ) }
						value={ desktop.bottom }
						onChange={ ( val ) => {
							const _padding = {
								...desktop,
								...{ bottom: val },
							};
							updateValues( { desktop: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Left' ) }
						value={ desktop.left }
						onChange={ ( val ) => {
							const _padding = {
								...desktop,
								...{ left: val },
							};
							updateValues( { desktop: _padding } );
						} } units={ units } />
				</Fragment>
				}
				{ 'tablet' === compState.device && <Fragment>
					<UnitControl
						disabled={ disabled }
						label={ __( 'Top' ) }
						value={ tablet.top }
						onChange={ ( val ) => {
							const _padding = {
								...tablet,
								...{ top: val },
							};
							updateValues( { tablet: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Right' ) }
						value={ tablet.right }
						onChange={ ( val ) => {
							const _padding = {
								...tablet,
								...{ right: val },
							};
							updateValues( { tablet: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Bottom' ) }
						value={ tablet.bottom }
						onChange={ ( val ) => {
							const _padding = {
								...tablet,
								...{ bottom: val },
							};
							updateValues( { tablet: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Left' ) }
						value={ tablet.left }
						onChange={ ( val ) => {
							const _padding = {
								...tablet,
								...{ left: val },
							};
							updateValues( { tablet: _padding } );
						} } units={ units } />
				</Fragment>
				}
				{ 'mobile' === compState.device && <Fragment>
					<UnitControl
						disabled={ disabled }
						label={ __( 'Top' ) }
						value={ mobile.top }
						onChange={ ( val ) => {
							const _padding = {
								...mobile,
								...{ top: val },
							};
							updateValues( { mobile: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Right' ) }
						value={ mobile.right }
						onChange={ ( val ) => {
							const _padding = {
								...mobile,
								...{ right: val },
							};
							updateValues( { mobile: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Bottom' ) }
						value={ mobile.bottom }
						onChange={ ( val ) => {
							const _padding = {
								...mobile,
								...{ bottom: val },
							};
							updateValues( { mobile: _padding } );
						} } units={ units } />
					<UnitControl
						disabled={ disabled }
						label={ __( 'Left' ) }
						value={ mobile.left }
						onChange={ ( val ) => {
							const _padding = {
								...mobile,
								...{ left: val },
							};
							updateValues( { mobile: _padding } );
						} } units={ units } />
				</Fragment>
				}
			</div>
		</BaseControl>
	</div>;
};

export default PaddingControl;
